import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom'
import './MobileMenu.css'

const MobileMenu = ({
  isOpen=false,
  TriggerElement=()=>null,
  menuItems: MenuItems=()=><code>nav items</code>
}) =>
  <div className="MobileMenu">
    <ul>
      <li className={"navigation "+(isOpen?"isOpen":"")}>
        <a><TriggerElement/></a>
        <ul className="dropdown">
          <MenuItems/>
          {/* <ul>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/help">Help</Link></li>
          </ul> */}
        </ul>
      </li>
    </ul>
  </div>


export default MobileMenu



// WEBPACK FOOTER //
// ./src/core/MobileMenu.js